import React from 'react';
import {convertDateToSpecificFormat} from '../../../../common/util/date';

export const columnsHistoryPrices = () => {
  return [
    {
      'Header': () => <span className='header-title'>ID</span>,
      'accessor': 'groupId',
    },
    {
      'Header': () => <span className='header-title'>COLOR INTERIOR</span>,
      'accessor': 'indoorColor',
    },
    {
      'Header': () => <span className='header-title'>COLOR INT. DESCRIPCIÓN</span>,
      'accessor': 'indoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>COLOR EXTERIOR</span>,
      'accessor': 'outdoorColor',
    },
    {
      'Header': () => <span className='header-title'>COLOR EXT. DESCRIPCIÓN</span>,
      'accessor': 'outdoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>FOB</span>,
      'accessor': 'fob',
      'Cell': ({row}) => <>{row.original.fob && `$ ${parseFloat(row.original.fob).toFixed(2)}`}</>,
    },
    {
      'Header': () => <span className='header-title'>FLETE</span>,
      'accessor': 'shippingCost',
      'Cell': ({row}) => <>{row.original.shippingCost && `$ ${parseFloat(row.original.shippingCost).toFixed(2)}`}</>,
    },
    {
      'Header': () => <span className='header-title'>VALOR COLOR</span>,
      'accessor': 'colorValue',
      'Cell': ({row}) => <>{row.original.colorValue && `$ ${parseFloat(row.original.colorValue).toFixed(2)}`}</>,
    },
    {
      'Header': () => <span className='header-title'>COMISIÓN</span>,
      'accessor': 'commission',
      'Cell': ({row}) => <>{row.original.commission && `$ ${parseFloat(row.original.commission).toFixed(2)}`}</>,
    },
    {
      'Header': () => <span className='header-title'>C&F</span>,
      'accessor': 'cif',
      'Cell': ({row}) => <>{row.original.cif && `$ ${parseFloat(row.original.cif).toFixed(2)}`}</>,
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD. INICIO</span>,
      'accessor': 'startDate',
      'Cell': ({row}) => <>{convertDateToSpecificFormat(row.original.startDate, 'MMM YYYY')}</>,
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD. FIN</span>,
      'accessor': 'endDate',
      'Cell': ({row}) => <>{convertDateToSpecificFormat(row.original.endDate, 'MMM YYYY')}</>,
    },
  ];
};
